/* SEV hotfix 2026-09-04: Shopify rebuilt the legacy option_selection.js with "use strict";
 * its Shopify.Product.prototype.update still uses an undeclared loop variable and now throws
 * "ReferenceError: property is not defined". That aborts Turbo's app.js init chain (variant
 * pickers, faceted filters, quantity box, currency). Redefine the method with a declared variable.
 * Loaded with defer right after option_selection.js so it runs after it and before DOMContentLoaded.
 * Remove when the theme is upgraded or option_selection.js is vendored into the theme. */
(function () {
  if (window.Shopify && Shopify.Product && Shopify.Product.prototype) {
    Shopify.Product.prototype.update = function (json) {
      for (var p in json) { this[p] = json[p]; }
    };
  }
})();
